import styled from "@emotion/styled";
import { DisplayText, ThemeText } from "components/lib";
import { LabelType } from "./page-header";
import freeToJoin from "assets/freeToJoin.png";
import JoinMembership from "assets/Join Membership.png";

const styleObj = {
  imgZh: { width: "28rem" },
};
export const PageRecharge = ({
  restaurantName,
  backRate,
  afterLoad,
  lang,
}: {
  restaurantName: string;
  backRate: number;
  afterLoad?: () => void;
  lang: LabelType;
}) => {
  const handleOnCload = () => {
    if (afterLoad) {
      afterLoad();
    }
  };

  return (
    <Wrapper>
      {/* 顶部34，左右两边40，下 26 */}
      {lang === "zh" ? (
        <RestaurantName>欢迎加入{restaurantName}会员</RestaurantName>
      ) : (
        <ThemeText style={{ fontWeight: 600, marginTop: "3rem" }}>
          Welcome to join {restaurantName}
        </ThemeText>
      )}
      {/* 顶部14 */}
      <JoinBackground>
        {lang === "zh" ? (
          <DisplayText>
            <img
              src={freeToJoin}
              style={styleObj.imgZh}
              onLoad={handleOnCload}
              loading="eager"
              alt="banner"
            ></img>
          </DisplayText>
        ) : (
          <DisplayText>
            <img
              src={JoinMembership}
              style={styleObj.imgZh}
              onLoad={handleOnCload}
              loading="eager"
              alt="banner"
            ></img>
          </DisplayText>
        )}
      </JoinBackground>
      {lang === "zh" ? (
        <DisplayText marginVal={"1rem 0 0 0"}>
          {!!backRate ? (
            <>
              <BonusZh>会员充值 最高返</BonusZh>
              <BackNum>{backRate}%</BackNum>
            </>
          ) : (
            <BonusZh s={"3.1rem"}>开通会员充值</BonusZh>
          )}
        </DisplayText>
      ) : (
        <>
          {backRate ? (
            <JoinTitleEn>{`Add Balance, Unlock Up to ${backRate}% Bonus!`}</JoinTitleEn>
          ) : (
            <JoinTitleEn>Add Balance</JoinTitleEn>
          )}
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  width: 29.5rem;
  margin: 0 auto;
`;

const RestaurantName = styled(ThemeText)`
  width: 29.5rem;
  margin: 3.4rem auto 0 auto;
  font-weight: 500;
`;

export const JoinBackground = styled.div`
  width: 29.5rem;
  height: 6rem;
  background: linear-gradient(90deg, #fee7c4 0%, #fbddb1 100%);
  border-radius: 1px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.4rem;
`;

const JoinTitleEn = styled.div`
  font-family: Avenir Next Condensed Back;
  font-size: 2.2rem;
  line-height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fee5c0;
  margin-top: 1.1rem;
`;

const BackNum = styled.span`
  font-family: Avenir Next Condensed Back;
  font-weight: bold;
  font-size: 3.1rem;
  color: #fee5c0;
  height: 4.2rem;
`;

export const BonusZh = styled(ThemeText) <{
  s?: string;
}>`
  font-family: Source Han Sans;
  font-weight: 900;
  white-space: nowrap;
  font-size: ${(props) => (props.s ? props.s : "3.1rem")};
  text-align: center;
`;
